<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">MONTHLY EVALUATION EMPLOYEES</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-5 mb-5">
        <v-flex xs12 md3>
          <v-select
            v-model="month_of_id"
            class="mx-2"
            dense
            outlined
            label="Month Of"
            :items="month_of_items"
            item-value="id"
            item-text="month_of"
            @change="selected_category"
          ></v-select>
        </v-flex>
        <v-flex xs12 md3>
          <v-select
            v-model="category_id"
            class="mx-2"
            dense
            outlined
            label="Category"
            :items="category_items"
            item-value="id"
            item-text="category"
            @change="selected_category"
          ></v-select>
        </v-flex>
        <v-flex xs12 md3 v-if="is_bod">
          <v-select
            v-model="employee_position_id"
            class="mx-2"
            dense
            outlined
            label="Position"
            :items="employee_position_items"
            item-value="id"
            item-text="position"
            @change="selected_data"
          ></v-select>
        </v-flex>
        <v-flex xs12 md3 v-if="is_bod">
          <v-select
            v-model="selected_department_id"
            class="mx-2"
            dense
            outlined
            label="Branch/Department"
            :items="employee_branch_items"
            item-value="id"
            item-text="branch_code"
            @change="selected_data"
          ></v-select>
        </v-flex>

        <v-flex xs12 md12 v-if="is_generated && !is_division">
          <v-select
            class="mx-2"
            v-model="bank"
            dense
            outlined
            label="Bank"
            :items="bank_items1"
            item-text="bank_type"
            item-value="bank_type"
            :rules="rules.combobox_rule"
            @change="selected_bank_data"
          ></v-select>
        </v-flex>
        <v-flex xs12 md12 v-if="is_generated && is_division">
          <v-select
            class="mx-2"
            v-model="bank"
            dense
            outlined
            label="Bank"
            :items="bank_items2"
            item-text="bank_type"
            item-value="bank_type"
            :rules="rules.combobox_rule"
            @change="selected_bank_data2"
          ></v-select>
        </v-flex>
        <v-col cols="12" v-show="alert">
          <v-alert
            color="warning"
            text
            class="mb-0"
          >
            <div class="d-flex align-start">
              <v-icon color="warning">
                {{ icons.mdiAlertOutline }}
              </v-icon>

              <div class="ms-3">
                <p class="text-base font-weight-medium mb-1">
                  {{ alert_message }}
                </p>
              </div>
            </div>
          </v-alert>
        </v-col>
        <v-col cols="12" md="12"
               v-if="(is_bod||is_executive_head) && !is_generated && (final_division_evaluation_data.length>0||final_manager_evaluation_data.length>0)">
          <v-btn
            class="w-full"
            color="success"
            @click="approved_data"
            v-if="!saving_data"
          >
            Approved
          </v-btn>
          <v-progress-circular
            :size=50
            :width="5"
            color="primary"
            indeterminate
            v-else
          ></v-progress-circular>
        </v-col>
        <v-col cols="12" md="12"
               v-if="(is_bod||is_executive_head) && is_generated&& (final_division_evaluation_data.length>0||final_manager_evaluation_data.length>0)">
          <v-btn
            class="w-full"
            color="info"
            @click="print_data"
            v-if="!is_printing"
          >
            Print Data
          </v-btn>
          <v-progress-circular
            :size=50
            :width="5"
            color="primary"
            indeterminate
            v-else
          ></v-progress-circular>
        </v-col>
      </v-layout>
      <v-toolbar dense dark color="primary" v-if="!is_division">
        <v-toolbar-title><h4 class="font-weight-light">MANAGERS</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table dense v-if="is_bod||is_executive_head||is_head||is_manager||is_csr||is_hr"
                    class="mt-3"
                    :headers="headers"
                    :items="final_manager_evaluation_data"
                    disable-pagination
                    hide-default-footer
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{
                (final_manager_evaluation_data
                  .map(function (x) {
                    return x.id
                  })
                  .indexOf(item.id) + 1)
              }}
            </td>
            <td>
              <div v-if="(!is_generated)">
                <div
                  v-if="(item.evaluation_points === 0&&(is_head||is_manager||is_executive_head||is_csr||is_hr))">
                  <v-icon
                    v-if="((employee_id!=item.id) || (employee_id===item.id&&(is_csr||is_hr)))"
                    color="info"
                    @click="change_stat_cash_advance(item,is_executive_head)"
                  >{{ icons.mdiBadgeAccountAlertOutline }}
                  </v-icon>
                </div>
                <div v-if="item.evaluation_points > 0">
                  {{ item.evaluation_points + ' points' }}
                </div>
              </div>
            </td>
            <td v-if="!is_generated">
              {{ item.name }}
            </td>
            <td v-else>
              {{
                item.employee.last_name + ', '
                + item.employee.first_name
                + ' ' + item.employee.middle_name
              }}
            </td>
            <td>
              {{ item.branch.branch_code }}
            </td>
            <td>
              {{ item.employee_position.position }}
            </td>
            <td>
              {{ item.duration }}
            </td>
            <td>
              {{
                (is_head || is_bod || is_executive_head) ? (!is_generated ? (item.kpi_percentage > 0 ? item.kpi_percentage + ' %' : '')
                  : (item.cfo_percentage > 0 ? item.cfo_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_head || is_bod || is_executive_head) ? (!is_generated ? (item.behavioral_percentage > 0 ? item.behavioral_percentage + ' %' : '')
                  : (item.head_percentage > 0 ? item.head_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_hr || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.attendance_percentage > 0 ? item.attendance_percentage + ' %' : '')
                  : (item.hr_percentage > 0 ? item.hr_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_hr || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.policy_percentage > 0 ? item.policy_percentage + ' %' : '')
                  : (item.hr_percentage2 > 0 ? item.hr_percentage2 + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_csr || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.csr_percentage > 0 ? item.csr_percentage + ' %' : '')
                  : (item.csr_and_gad_percentage > 0 ? item.csr_and_gad_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_head || is_bod || is_executive_head) ? (!is_generated ? (item.performance_percentage > 0 ? item.performance_percentage + ' %' : '')
                  : (item.bod_hilario_percentage > 0 ? item.bod_hilario_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (
                  (is_bod || is_executive_head) ||
                  (is_generated && ((employee_id === item.employee_id) || is_hr))
                ) ? (item.total_percentage > 0 ? item.total_percentage + ' %' : '') : ''
              }}
            </td>
            <td>
              {{
                (
                  (is_bod || is_executive_head) ||
                  (is_generated && ((employee_id === item.employee_id) || is_hr))
                ) ? (item.incentives > 0 ? formatPrice(item.incentives) : '') : ''
              }}
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-toolbar dense dark color="primary" class="mt-10">
        <v-toolbar-title><h4 class="font-weight-light">DIVISIONS</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table dense
                    class="mt-3"
                    :headers="headers"
                    :items="final_division_evaluation_data"
                    disable-pagination
                    hide-default-footer
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{
                (final_division_evaluation_data
                  .map(function (x) {
                    return x.id
                  })
                  .indexOf(item.id) + 1)
              }}
            </td>
            <td>
              <div v-if="(!is_generated)">
                <div
                  v-if="(item.evaluation_points === 0&&(is_head||is_manager||is_executive_head||is_csr||is_hr))">
                  <v-icon
                    v-if="((employee_id!=item.id) || (employee_id===item.id&&(is_csr))||is_hr)"
                    color="info"
                    @click="change_stat_cash_advance(item,is_bod)"
                  >{{ icons.mdiBadgeAccountAlertOutline }}
                  </v-icon>
                </div>
                <div v-if="item.evaluation_points > 0">
                  {{ item.evaluation_points + ' points' }}
                </div>
              </div>
            </td>
            <td v-if="!is_generated">
              {{ item.name }}
            </td>
            <td v-else>
              {{
                item.employee.last_name + ', '
                + item.employee.first_name
                + ' ' + item.employee.middle_name
              }}
            </td>
            <td>
              {{ item.branch.branch_code }}
            </td>
            <td>
              {{ item.employee_position.position }}
            </td>
            <td>
              {{ item.duration }}
            </td>
            <td>
              {{
                (is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.kpi_percentage > 0 ? item.kpi_percentage + ' %' : '')
                  : (item.cfo_percentage > 0 ? item.cfo_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.behavioral_percentage > 0 ? item.behavioral_percentage + ' %' : '')
                  : (item.head_percentage > 0 ? item.head_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_hr || is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.attendance_percentage > 0 ? item.attendance_percentage + ' %' : '')
                  : (item.hr_percentage > 0 ? item.hr_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_hr || is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.policy_percentage > 0 ? item.policy_percentage + ' %' : '')
                  : (item.hr_percentage2 > 0 ? item.hr_percentage2 + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_csr || is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.csr_percentage > 0 ? item.csr_percentage + ' %' : '')
                  : (item.csr_and_gad_percentage > 0 ? item.csr_and_gad_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (is_manager || is_head || is_bod || is_executive_head) ? (!is_generated ? (item.performance_percentage > 0 ? item.performance_percentage + ' %' : '')
                  : (item.bod_hilario_percentage > 0 ? item.bod_hilario_percentage + ' %' : '')) : ''
              }}
            </td>
            <td>
              {{
                (
                  (is_manager || is_head || is_bod || is_executive_head) ||
                  (is_generated && ((employee_id === item.employee_id) || is_hr))
                ) ? (item.total_percentage > 0 ? item.total_percentage + ' %' : '') : ''
              }}
            </td>
            <td>
              {{
                (
                  (is_manager || is_head || is_bod || is_executive_head) ||
                  (is_generated && ((employee_id === item.employee_id) || is_hr))
                ) ? (item.incentives > 0 ? formatPrice(item.incentives) : '') : ''
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="is_change_salary" persistent max-width="70%">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">PEER EVALUATION FORM</h4>
          </v-toolbar-title>
        </v-toolbar>
        <!--     Wala dapat ni kay madamay ubang question   -->
        <!--        <v-radio-group-->
        <!--          class="mx-4"-->
        <!--          mandatory-->
        <!--          v-model="all_answer"-->
        <!--          row-->
        <!--          @change="change_all_answer"-->
        <!--        >-->
        <!--          <v-spacer></v-spacer>-->
        <!--          <v-radio v-for="row in answer_row"-->
        <!--                   :key="row.value"-->
        <!--                   :label="row.label"-->
        <!--                   :value="row.value"-->
        <!--          ></v-radio>-->
        <!--        </v-radio-group>-->
        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-card class="w-full"
                  v-if="((is_head&&selected_employee.is_manager)||(is_manager&&selected_employee.is_division))&&is_same_department">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Core Performance: Quality of Work
                (50%)</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-4"
                v-for="commu in key_performance"
                mandatory
                v-model="commu.model"
                row
              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <v-card class="w-full"
                  v-if="(is_head&&is_same_department)">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Behavioral Competencies: Teamwork,
                Initiative, and Cooperation (20%)</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-2"
                v-for="commu in behavioral"
                mandatory
                v-model="commu.model"
                row

              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <v-card class="w-full" v-if="(is_hr)">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Attendance and
                Punctuality (7.5%) </h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-2"
                v-for="commu in attendances"
                mandatory
                v-model="commu.model"
                row

              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <v-card class="w-full"
                  v-if="(is_hr)">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Policy Adherence (7.5%)</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-2"
                v-for="commu in policy_adherence"
                mandatory
                v-model="commu.model"
                row

              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <v-card class="w-full" v-if="(is_csr)">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Corporate Social Responsibility
                (10%)</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-2"
                v-for="commu in csr_ques"
                mandatory
                v-model="commu.model"
                row

              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <v-card class="w-full"
                  v-if="(is_executive_head)">
            <v-toolbar dense dark color="primary">
              <v-toolbar-title><h4 class="font-weight-light">Company Performance (5%)</h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-flex xs12 md12>
              <v-radio-group
                class="mx-2"
                v-for="commu in company_performance"
                mandatory
                v-model="commu.model"
                row

              >{{ commu.label }}
                <v-spacer></v-spacer>
                <v-radio v-for="row in answer_row"
                         :key="row.value"
                         :label="row.label"
                         :value="row.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card>
          <!--          <v-flex xs12 md12>-->
          <!--            <v-textarea-->
          <!--              class="mx-2 mt-3"-->
          <!--              v-model="comment"-->
          <!--              dense-->
          <!--              label="Comment"-->
          <!--              outlined-->
          <!--              :rules="rules.default_max_500_character_rule"-->
          <!--            ></v-textarea>-->
          <!--          </v-flex>-->
        </v-layout>
        <v-btn class="mt-4 w-full" color="primary" @click="update_cash_advance_previlige"
               v-if="!saving"> Save
        </v-btn>
        <v-progress-circular
          :size=50
          :width="5"
          color="primary"
          indeterminate
          v-else
        ></v-progress-circular>
        <v-btn class="mt-4 w-full" color="error" @click="is_change_salary = false"> Close</v-btn>
      </v-card>
    </v-dialog>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {
  mdiAccountOutline, mdiAccountCashOutline
  , mdiInformationOutline
  , mdiBadgeAccountAlertOutline
  , mdiPrinter
  , mdiEyeCircle
} from "@mdi/js";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    alert: false,
    alert_message: '',

    is_change_salary: false,
    is_same_department: false,
    is_generated: false,
    saving_data: false,
    is_printing: false,
    saving: false,
    is_head: false,
    is_manager: false,
    is_division: false,
    is_hr: false,
    is_executive_head: false,
    is_executive: false,
    is_bod: false,
    is_csr: false,
    category_id: '',
    new_incentives: '0',
    employee_position_id: 0,
    month_of_id: '',
    comment: '',
    category_items: [],
    month_of_items: [],
    category_items2: [],
    selected_department_id: '',
    employee_branch_items: [],
    comments_items: [],
    final_manager_evaluation_data: [],
    final_division_evaluation_data: [],
    bank_info: [],
    employment_info: [],
    type_of_employee: [],
    employee_position_items: [],
    points_items: [],
    bank_items2: [],
    bank_items1: [],
    all_items: [],
    sorted_by: 'Name',
    bank: '',
    status: 'All',
    duration: 'All',
    maximum_amount: '',
    selected_employee: {},
    all_answer: '0',
    key_performance: [
      {
        model: '0',
        label: 'Demonstrates strong knowledge pf accounting principles, standards, and company policies.'
      },
      {
        model: '0',
        label: 'Accurately records financial transactions and maintain proper documentation.'
      },
      {model: '0', label: 'Prepares financial reports correctly and in accordance with deadlines.'},
      {
        model: '0',
        label: 'Applies proper accounting treatments to complex or unusual transactions.'
      },
      {
        model: '0',
        label: 'Understands and complies with internal controls and audit requirements.'
      },
      {model: '0', label: 'Ensure accuracy of financial data, reports, and reconciliation.'},
      {model: '0', label: 'Maintains organized and well-documented files for easy reference.'},
      {model: '0', label: 'Complete assigned tasks within agreed timelines.'},
      {model: '0', label: 'Handles multiple tasks without compromising accuracy.'},
      {model: '0', label: 'Demonstrates reliability and consistency in work output.'},
    ],
    behavioral: [
      {model: '0', label: 'Work effectively with team members to achieve shared goals.'},
      {
        model: '0',
        label: 'Share information, knowledge and resources with colleagues in a timely manner.'
      },
      {model: '0', label: 'Contribute ideas and effort during team discussions and activities.'},
      {model: '0', label: 'Respect diverse opinions, roles, and responsibilities within the team.'},
      {
        model: '0',
        label: 'Respond constructively to feedback, instructions, and differing viewpoints.'
      },
      {
        model: '0',
        label: 'Willingly assist others when help is needed, even if outside regular duties.'
      },
      {model: '0', label: 'Provides constructive support during financial planning or reviews.'},
      {model: '0', label: 'Keeps accounting and finance knowledge up to date.'},
      {model: '0', label: 'Shows initiative in improving processes or controls.'},
      {model: '0', label: 'Demonstrates integrity and ethical behavior at all times.'},
    ],
    attendances: [
      {model: '0', label: 'Report to work on time as scheduled.'},
      {model: '0', label: 'Maintain regular attendance with minimal unplanned absences.'},
      {model: '0', label: 'Comply with timekeeping and attendance reporting requirements.'},
      {
        model: '0',
        label: 'Accept responsibility for attendance or policy related issues when they occur.'
      },
      {model: '0', label: 'Demonstrate knowledge of attendance policies and procedures.'},
    ],
    policy_adherence: [
      {model: '0', label: 'Consistently wear the prescribed uniform in accordance with policy'},
      {model: '0', label: 'Maintains professional grooming and appearance at all times.'},
      {
        model: '0',
        label: 'Comply with company established polices, procedures, and regulatory requirements such as code of conduct etc.'
      },
      {
        model: '0',
        label: 'Actively support and participate in programs, activities, and other initiatives that strengthens employee engagement.'
      },
      {
        model: '0',
        label: 'Demonstrate enthusiasm and willingness to be involved in company program and activities'
      },
    ],
    csr_ques: [
      {model: '0', label: 'Supports company-sponsored community outreach or CSR programs.'},
      {model: '0', label: 'Helps ensure community activities achieve their intended objectives.'},
      {
        model: '0',
        label: 'Support the foundations plans and programs of the Livelihood, Youth, Community, Health, Education, and Environment (LYCHEE) Sectors and the designated district.'
      },
      {model: '0', label: 'Shows genuine interest and commitment during community engagements.'},
      {model: '0', label: 'Promotes responsible and inclusive practices.'},
    ],
    company_performance: [
      {model: '0', label: 'Demonstrate commitment to long-term sustainable business practices.'},
      {model: '0', label: 'Upholds the company`s reputation through responsible actions.'},
      {
        model: '0',
        label: 'Demonstrate ethical behavior in the workplace and in all business dealings.'
      },
      {
        model: '0',
        label: 'Supports company initiatives aimed at environmental sustainability, corporate social responsibility, and expansion programs.'
      },
      {model: '0', label: 'Contribute positively to workplace culture and employee well-being.'},
    ],
    answer_row: [
      {label: '0', value: '0'},
      {label: '1', value: '1'},
      {label: '2', value: '2'},
      {label: '3', value: '3'},
      {label: '4', value: '4'},
      {label: '5', value: '5'},
    ],
    headers: [
      {text: 'No.', value: 'date_of_deposit', sortable: false},
      {text: 'Evaluate', value: 'last_name', sortable: false},
      {text: 'Name', value: 'name', sortable: true},
      {text: 'Branch/Department', value: 'branch.branch_code', sortable: true},
      {text: 'Designation', value: 'employee_position.position', sortable: true},
      {text: 'Duration', value: 'last_name', sortable: true},
      {text: 'KPI(50%)', value: 'employee_percentage', sortable: true},
      {text: 'Behavioral(20%)', value: 'employee_percentage', sortable: true},
      {text: 'Compliance Attendance(7.5%)', value: 'employee_percentage', sortable: true},
      {text: 'Compliance Policy Adherence(7.5%)', value: 'employee_percentage', sortable: true},
      {text: 'CSR(10%)', value: 'head_percentage', sortable: true},
      {text: 'Perfomance(5%)', value: 'cfo_percentage', sortable: true},
      {text: 'Total Points (100%)', value: 'total_percentage', sortable: true},
      {text: 'Incentives', value: 'incentives', sortable: true},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiInformationOutline,
        mdiBadgeAccountAlertOutline,
        mdiEyeCircle,
        mdiPrinter,
      },
      is_deleting: false,
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.is_bod = this.employee_id === 2 || this.employee_id === 1 || this.employee_id === 3
    if (!this.is_can_evaluate) {
      this.$router.push({path: '/error-404'})
    }
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['position', 'is_can_evaluate']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo', 'damayan', 'chapel', 'factory', 'coop', 'printing']),
    ...mapGetters('authentication', ['position', 'id_no', 'employee_category_id', 'employee_id', 'employee_department_id']),
    ...mapGetters('authentication', ['address', 'contact', 'name', 'department', 'position']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('employee_evaluation', ['evaluate_employee', 'list_of_employee_to_evaluate', 'list_of_employee_to_evaluate_in_department', 'evaluate_below_employee', 'list_of_executive_employee_to_evaluate', 'list_of_manager_employee_to_evaluate']),
    ...mapActions('employee', ['initialize_list_of_employee_for_evaulation', 'is_manager_checker_employee', 'is_division_checker_employee', 'is_head_checker_employee', 'is_csr_gad_checker_employee', 'is_hr_checker_employee', 'is_executive_head_checker_employee', 'is_executive_checker_employee']),
    ...mapActions('employee_evaluation_status', ['create_employee_is_done_evaluate']),
    ...mapActions('employee_evaluation_data', ['create_employee_evaluation_data']),
    is_same_department_checker(value) {
      return (this.employee_department_id === value)
    },
    employee_status_checker(value) {
      this.is_head_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_head = response.data;
        })
      this.is_manager_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_manager = response.data;
        })
      this.is_division_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_division = response.data;
        })
      this.is_csr_gad_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_csr = response.data[0].is_csr;
        })
      this.is_hr_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_hr = response.data;
        })
      this.is_executive_head_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_executive_head = response.data;
        })
    },
    change_all_answer() {
      this.key_performance[0].model = this.all_answer
      this.key_performance[1].model = this.all_answer
      this.key_performance[2].model = this.all_answer
      this.key_performance[3].model = this.all_answer
      this.key_performance[4].model = this.all_answer
      this.key_performance[5].model = this.all_answer
      this.key_performance[6].model = this.all_answer
      this.key_performance[7].model = this.all_answer
      this.key_performance[8].model = this.all_answer
      this.key_performance[9].model = this.all_answer
      this.behavioral[0].model = this.all_answer
      this.behavioral[1].model = this.all_answer
      this.behavioral[2].model = this.all_answer
      this.behavioral[3].model = this.all_answer
      this.behavioral[4].model = this.all_answer
      this.behavioral[5].model = this.all_answer
      this.behavioral[6].model = this.all_answer
      this.behavioral[7].model = this.all_answer
      this.behavioral[8].model = this.all_answer
      this.behavioral[9].model = this.all_answer
      this.attendances[0].model = this.all_answer
      this.attendances[1].model = this.all_answer
      this.attendances[2].model = this.all_answer
      this.attendances[3].model = this.all_answer
      this.attendances[4].model = this.all_answer
      this.policy_adherence[0].model = this.all_answer
      this.policy_adherence[1].model = this.all_answer
      this.policy_adherence[2].model = this.all_answer
      this.policy_adherence[3].model = this.all_answer
      this.policy_adherence[4].model = this.all_answer
      this.csr_ques[0].model = this.all_answer
      this.csr_ques[1].model = this.all_answer
      this.csr_ques[2].model = this.all_answer
      this.csr_ques[3].model = this.all_answer
      this.csr_ques[4].model = this.all_answer
      this.company_performance[0].model = this.all_answer
      this.company_performance[1].model = this.all_answer
      this.company_performance[2].model = this.all_answer
      this.company_performance[3].model = this.all_answer
      this.company_performance[4].model = this.all_answer
    },
    async initialize_data() {
      await this.employee_status_checker(this.employee_id)
      await this.initialize_list_of_employee_for_evaulation()
        .then(response => {
          this.category_items2 = response.data[0].category
          this.month_of_items = response.data[0].months
        })
        .catch(error => {
          console.log(error)
        })
      if (this.employee_category_id === 1) {
        this.category_items.push(this.category_items2[
          this.category_items2
            .map(function (x) {
              return x.id
            })
            .indexOf(2)
          ])
      } else {
        this.category_items.push(this.category_items2[
          this.category_items2
            .map(function (x) {
              return x.id
            })
            .indexOf(this.employee_category_id)
          ])
      }
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    change_stat_cash_advance(value, is_can_change_salary) {
      this.selected_employee = value
      if (is_can_change_salary) {
        this.is_change_salary = true
      } else {
        this.is_same_department = this.is_same_department_checker(value.department_id)
        this.is_change_salary = true
      }
    },
    update_cash_advance_previlige() {
      this.saving = true
      var proceed = true;
      if (proceed) {
        this.alert = false
        this.alert_message = ''
        this.saving_data = false
        this.saving = false
        this.evaluate_employee({
          month_of_id: this.month_of_id,
          created_by: this.employee_id,
          employee_id: this.selected_employee.id,
          is_executive_head: this.is_executive_head,
          is_head: this.is_head,
          is_manager: this.is_manager,
          is_hr: this.is_hr,
          is_csr: this.is_csr,

          q1: this.key_performance[0].model,
          q2: this.key_performance[1].model,
          q3: this.key_performance[2].model,
          q4: this.key_performance[3].model,
          q5: this.key_performance[4].model,
          q6: this.key_performance[5].model,
          q7: this.key_performance[6].model,
          q8: this.key_performance[7].model,
          q9: this.key_performance[8].model,
          q10: this.key_performance[9].model,

          q11: this.behavioral[0].model,
          q12: this.behavioral[1].model,
          q13: this.behavioral[2].model,
          q14: this.behavioral[3].model,
          q15: this.behavioral[4].model,
          q16: this.behavioral[5].model,
          q17: this.behavioral[6].model,
          q18: this.behavioral[7].model,
          q19: this.behavioral[8].model,
          q20: this.behavioral[9].model,

          q21: this.attendances[0].model,
          q22: this.attendances[1].model,
          q23: this.attendances[2].model,
          q24: this.attendances[3].model,
          q25: this.attendances[4].model,

          q26: this.policy_adherence[0].model,
          q27: this.policy_adherence[1].model,
          q28: this.policy_adherence[2].model,
          q29: this.policy_adherence[3].model,
          q30: this.policy_adherence[4].model,

          q31: this.csr_ques[0].model,
          q32: this.csr_ques[1].model,
          q33: this.csr_ques[2].model,
          q34: this.csr_ques[3].model,
          q35: this.csr_ques[4].model,

          q36: this.company_performance[0].model,
          q37: this.company_performance[1].model,
          q38: this.company_performance[2].model,
          q39: this.company_performance[3].model,
          q40: this.company_performance[4].model,

        }).then(response => {
          this.alert = true
          this.alert_message = response.data
          this.saving_data = false
          this.saving = false
          this.selected_data()
        })
          .catch(error => {
            console.log(error)
          })
      }
    },
    selected_category() {
      if (this.category_items.length > 0) {
        var index = this.category_items
          .map(function (x) {
            return x.id
          })
          .indexOf(this.category_id)
        if (index >= 0) {
          this.employee_position_items.splice(0, 0, {
            id: 0,
            position: 'All'
          })
          this.employee_branch_items = this.category_items[index].branch
          this.employee_branch_items.splice(0, 0, {
            id: 0,
            branch_code: 'All'
          })
          this.selected_data()
        }
      }
    },
    selected_bank_data() {
      var index = this.bank_items1
        .map(function (x) {
          return x.bank_type
        })
        .indexOf(this.bank)
      if (index >= 0) {
        this.final_manager_evaluation_data = this.bank_items1[index].detail
        this.final_division_evaluation_data = this.bank_items2[index].detail
      }
    },
    selected_bank_data2() {
      var index = this.bank_items2
        .map(function (x) {
          return x.bank_type
        })
        .indexOf(this.bank)
      if (index >= 0) {
        this.final_division_evaluation_data = this.bank_items2[index].detail
      }
    },
    selected_data() {
      this.reset_question()
      if (!this.is_bod) {
        this.selected_department_id = this.employee_department_id
      }
      this.selected_employee = {}
      this.is_change_salary = false
      this.is_same_department = false
      this.is_generated = false
      const data = new FormData()
      this.final_manager_evaluation_data = []
      this.final_division_evaluation_data = []
      data.append('month_of_id', this.month_of_id);
      data.append('created_by', this.employee_id);
      data.append('is_bod', this.is_bod ? 1 : 0);
      data.append('is_executive_head', this.is_executive_head);
      data.append('is_head', this.is_head);
      data.append('is_manager', this.is_manager);
      data.append('is_division', this.is_division);
      data.append('is_hr', this.is_hr);
      data.append('is_csr', this.is_csr);
      data.append('department_id', this.selected_department_id);
      data.append('category_id', this.category_id);
      this.manager_data(data)
      this.division_data(data)
      this.saving = false
    },
    division_data(data) {
      this.list_of_employee_to_evaluate_in_department(data)
        .then(response => {
          if (response.data[0].details === 'generated') {
            this.is_generated = true
            this.bank_items2 = response.data[0].data
          } else {
            this.final_division_evaluation_data = this.evaluation_data(response.data[0].data, this.employee_id)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    manager_data(data) {
      this.list_of_manager_employee_to_evaluate(data)
        .then(response => {
          if (response.data[0].details === 'generated') {
            this.is_generated = true
            this.bank_items1 = response.data[0].data
          } else {
            this.final_manager_evaluation_data = this.evaluation_data(response.data[0].data, this.employee_id)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    evaluation_data(data, emp_id) {
      let temp = []
      data.forEach(function (item) {
        let kpi = 0
        let beh = 0
        let atte = 0
        let poli = 0
        let ccss = 0
        let perrrr = 0
        let my_points = 0

        item.evaluation.forEach(function (item) {
          kpi += (parseFloat(item.q1) + parseFloat(item.q2) + parseFloat(item.q3) + parseFloat(item.q4) + parseFloat(item.q5) + parseFloat(item.q6) + parseFloat(item.q7) + parseFloat(item.q8) + parseFloat(item.q9) + parseFloat(item.q10))
          beh += (parseFloat(item.q11) + parseFloat(item.q12) + parseFloat(item.q13) + parseFloat(item.q14) + parseFloat(item.q15) + parseFloat(item.q16) + parseFloat(item.q17) + parseFloat(item.q18) + parseFloat(item.q19) + parseFloat(item.q20))
          atte += (parseFloat(item.q21) + parseFloat(item.q22) + parseFloat(item.q23) + parseFloat(item.q24) + parseFloat(item.q25))
          poli += (parseFloat(item.q26) + parseFloat(item.q27) + parseFloat(item.q28) + parseFloat(item.q29) + parseFloat(item.q30))
          ccss += (parseFloat(item.q31) + parseFloat(item.q32) + parseFloat(item.q33) + parseFloat(item.q34) + parseFloat(item.q35))
          perrrr += (parseFloat(item.q36) + parseFloat(item.q37) + parseFloat(item.q38) + parseFloat(item.q39) + parseFloat(item.q40))

          my_points += item.created_by === emp_id ? parseFloat(item.total) : 0
        })
        let total_points = kpi + beh + atte + poli + ccss + perrrr
        let kpi_percentage = (((kpi / 10) / 5) * 50).toFixed(2)
        let behavioral_percentage = (((beh / 10) / 5) * 20).toFixed(2)
        let attendance_percentage = (((atte / 5) / 5) * 7.5).toFixed(2)
        let policy_percentage = (((poli / 5) / 5) * 7.5).toFixed(2)
        let csr_percentage = (((ccss / 5) / 5) * 10).toFixed(2)
        let performance_percentage = (((perrrr / 5) / 5) * 5).toFixed(2)
        var total_percentage = (parseFloat(kpi_percentage) + parseFloat(behavioral_percentage) + parseFloat(attendance_percentage) + parseFloat(policy_percentage) + parseFloat(csr_percentage) + parseFloat(performance_percentage)).toFixed(2);
        var ince = 0
        var temp_total = parseFloat(total_percentage).toFixed()
        if (temp_total >= 96 && temp_total <= 100) {
          ince = 3000;
        } else if (temp_total >= 91 && temp_total <= 95) {
          ince = 2500;
        } else if (temp_total >= 86 && temp_total <= 90) {
          ince = 2000;
        } else if (temp_total >= 81 && temp_total <= 85) {
          ince = 1500;
        } else if (temp_total === 80) {
          ince = 1000;
        }

        var a = moment();
        var b = moment(item.date_of_employment, 'YYYY-MM-DD');

        var years = a.diff(b, 'year');
        b.add(years, 'years');

        var months = a.diff(b, 'months');
        b.add(months, 'months');

        var days = a.diff(b, 'days');
        temp.push({
          id: item.id,
          is_manager: item.sg === 7 ? 1 : 0,
          is_head: item.sg === 8 ? 1 : 0,
          is_executive: (item.sg === 9 || item.sg === 10) ? 1 : 0,
          is_division: item.sg < 7 ? 1 : 0,
          branch: item.branch,
          branch_id: item.branch_id,
          department_id: item.department_id,
          employee_position: item.employee_position,
          duration: years + ' years ' + months + ' months ' + days + ' days',
          bank_type: item.bank_type_1,
          bank_account_name: item.bank_account_1,
          bank_account_no: item.bank_account_no_1,

          employee_points: total_points,
          employee_percentage: 0,

          kpi_points: kpi,
          kpi_percentage: kpi_percentage,
          behavioral_points: beh,
          behavioral_percentage: behavioral_percentage,
          attendance_points: atte,
          attendance_percentage: attendance_percentage,
          policy_points: poli,
          policy_percentage: policy_percentage,
          csr_points: ccss,
          csr_percentage: csr_percentage,
          performance_points: perrrr,
          performance_percentage: performance_percentage,

          name: item.last_name + ','
            + item.first_name + ' ' + item.middle_name,

          date_of_employment: item.date_of_employment,
          evaluation_points: my_points,
          total_percentage: total_percentage,
          incentives: ince,
        })
      })
      return temp;
    },
    approved_data() {
      this.saving_data = true
      this.alert = false


      var can_final = true
      if (can_final) {
        const data = new FormData()
        data.append('month_of_id', this.month_of_id);
        data.append('category_id', this.category_id);
        data.append('evaluation_data_managers', JSON.stringify(this.final_manager_evaluation_data));
        data.append('evaluation_data_department', JSON.stringify(this.final_division_evaluation_data));
        console.log(data)
        this.create_employee_evaluation_data(data)
          .then(() => {
            this.saving_data = false
            this.selected_data()
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.alert = true
        this.alert_message = 'Not all employee evaluated'
        this.saving_data = false
      }
    },
    reset_question() {

      this.all_answer = '0'
      this.key_performance = [
        {
          model: '0',
          label: 'Demonstrates strong knowledge pf accounting principles, standards, and company policies.'
        },
        {
          model: '0',
          label: 'Accurately records financial transactions and maintain proper documentation.'
        },
        {
          model: '0',
          label: 'Prepares financial reports correctly and in accordance with deadlines.'
        },
        {
          model: '0',
          label: 'Applies proper accounting treatments to complex or unusual transactions.'
        },
        {
          model: '0',
          label: 'Understands and complies with internal controls and audit requirements.'
        },
        {model: '0', label: 'Ensure accuracy of financial data, reports, and reconciliation.'},
        {model: '0', label: 'Maintains organized and well-documented files for easy reference.'},
        {model: '0', label: 'Complete assigned tasks within agreed timelines.'},
        {model: '0', label: 'Handles multiple tasks without compromising accuracy.'},
        {model: '0', label: 'Demonstrates reliability and consistency in work output.'},
      ]
      this.behavioral = [
        {model: '0', label: 'Work effectively with team members to achieve shared goals.'},
        {
          model: '0',
          label: 'Share information, knowledge and resources with colleagues in a timely manner.'
        },
        {model: '0', label: 'Contribute ideas and effort during team discussions and activities.'},
        {
          model: '0',
          label: 'Respect diverse opinions, roles, and responsibilities within the team.'
        },
        {
          model: '0',
          label: 'Respond constructively to feedback, instructions, and differing viewpoints.'
        },
        {
          model: '0',
          label: 'Willingly assist others when help is needed, even if outside regular duties.'
        },
        {model: '0', label: 'Provides constructive support during financial planning or reviews.'},
        {model: '0', label: 'Keeps accounting and finance knowledge up to date.'},
        {model: '0', label: 'Shows initiative in improving processes or controls.'},
        {model: '0', label: 'Demonstrates integrity and ethical behavior at all times.'},
      ]
      this.attendances = [
        {model: '0', label: 'Report to work on time as scheduled.'},
        {model: '0', label: 'Maintain regular attendance with minimal unplanned absences.'},
        {model: '0', label: 'Comply with timekeeping and attendance reporting requirements.'},
        {
          model: '0',
          label: 'Accept responsibility for attendance or policy related issues when they occur.'
        },
        {model: '0', label: 'Demonstrate knowledge of attendance policies and procedures.'},
      ]
      this.policy_adherence = [
        {model: '0', label: 'Consistently wear the prescribed uniform in accordance with policy'},
        {model: '0', label: 'Maintains professional grooming and appearance at all times.'},
        {
          model: '0',
          label: 'Comply with company established polices, procedures, and regulatory requirements such as code of conduct etc.'
        },
        {
          model: '0',
          label: 'Actively support and participate in programs, activities, and other initiatives that strengthens employee engagement.'
        },
        {
          model: '0',
          label: 'Demonstrate enthusiasm and willingness to be involved in company program and activities'
        },
      ]
      this.csr_ques = [
        {model: '0', label: 'Supports company-sponsored community outreach or CSR programs.'},
        {model: '0', label: 'Helps ensure community activities achieve their intended objectives.'},
        {
          model: '0',
          label: 'Support the foundations plans and programs of the Livelihood, Youth, Community, Health, Education, and Environment (LYCHEE) Sectors and the designated district.'
        },
        {model: '0', label: 'Shows genuine interest and commitment during community engagements.'},
        {model: '0', label: 'Promotes responsible and inclusive practices.'},
      ]
      this.company_performance = [
        {model: '0', label: 'Demonstrate commitment to long-term sustainable business practices.'},
        {model: '0', label: 'Upholds the company`s reputation through responsible actions.'},
        {
          model: '0',
          label: 'Demonstrate ethical behavior in the workplace and in all business dealings.'
        },
        {
          model: '0',
          label: 'Supports company initiatives aimed at environmental sustainability, corporate social responsibility, and expansion programs.'
        },
        {model: '0', label: 'Contribute positively to workplace culture and employee well-being.'},
      ]
    },
    print_data() {
      this.is_printing = true
      this.alert = false

      var imgData = this.company_logo
      var payments_array = []
      var payments_array2 = []
      var widths = []
      var info_array = []
      var info_array3 = []
      var info_array2 = []
      widths = [20, 120, 120, 80, 80, 30, 50]
      payments_array.push([
        {text: 'No.', alignment: 'left', style: 'main_info',},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Branch/Department', alignment: 'left', style: 'main_info'},
        {text: 'Designation', alignment: 'left', style: 'main_info'},
        {text: 'Duration', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Incentives', alignment: 'left', style: 'main_info'},
      ])
      payments_array2.push([
        {text: 'No.', alignment: 'left', style: 'main_info',},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Branch/Department', alignment: 'left', style: 'main_info'},
        {text: 'Designation', alignment: 'left', style: 'main_info'},
        {text: 'Duration', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Incentives', alignment: 'left', style: 'main_info'},
      ])
      var value1 = this.final_manager_evaluation_data;
      var value2 = this.final_division_evaluation_data;
      var total_am = 0
      value1.forEach(function (item) {
        total_am += parseFloat(item.incentives)
        payments_array.push([
          {
            text: (value1
              .map(function (x) {
                return x.id
              })
              .indexOf(item.id) + 1),
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.employee.last_name + ', ' +
              item.employee.first_name + ' ' + item.employee.middle_name,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.branch.branch_code,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.employee_position.position,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.duration,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.total_percentage + '%',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.incentives / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
      })
      value2.forEach(function (item) {
        total_am += parseFloat(item.incentives)
        payments_array2.push([
          {
            text: (value2
              .map(function (x) {
                return x.id
              })
              .indexOf(item.id) + 1),
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.employee.last_name + ', ' +
              item.employee.first_name + ' ' + item.employee.middle_name,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.branch.branch_code,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.employee_position.position,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.duration,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.total_percentage + '%',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.incentives / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
      })

      info_array3 = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'Bank Type: ',
                {
                  text: this.bank_items1[this.bank_items1.map(function (x) {
                    return x.bank_type;
                  }).indexOf(this.bank)].bank_type,
                  style: 'main_data',
                },
              ],
            },
          ],
        }, {
          columns: [
            {
              style: 'main_info',
              text: [
                'Category: ',
                {
                  text: this.category_items[this.category_items.map(function (x) {
                    return x.id;
                  }).indexOf(this.category_id)].category,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                {
                  text: 'Month Of: ' + this.month_of_items[this.month_of_items.map(function (x) {
                    return x.id;
                  }).indexOf(this.month_of_id)].month_of,
                  style: 'main_data',
                },
              ],
            },

          ],
        }, {
          columns: [
            {
              style: 'main_info',
              text: [
                {
                  text: 'Total Of: ' + (total_am / 1)
                    .toFixed(2)
                    .replace(',', '.')
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  style: 'main_data',
                },
              ],
            },

          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'EXECUTIVES',
              ],
            },
          ],
        },
      ]
      info_array2 = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'DEPARTMENTS',
              ],
            },
          ],
        },
      ]
      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'HEADS',
              ],
            },
          ],
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: this.address, style: 'subheader'},
                  {
                    text: this.contact,
                    style: 'subheader',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
            ],
          },
          '_______________________________________________________________________________________________',
          {
            stack: [
              {
                columns: [
                  {
                    text: 'EMPLOYEE PERFORMANCE BASE BUNOS',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                      color: 'blue',
                    },
                  },
                ],
              },
            ],
          },
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array3,
          },
          {
            columns: [{text: ' '}],
          },
          '_______________________________________________________________________________________________',
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
          },
          '_______________________________________________________________________________________________',
          {
            stack: info_array2,
          },
          {
            table: {
              widths: widths,
              body: payments_array2,
              style: {fontSize: 1},
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: '',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_________________________________________',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2',
                  },
                  {
                    text: '',
                  },
                  {
                    text: '',
                  },
                ],
              },
            ],
          },
          {
            columns: [
              {image: this.damayan, width: 54, height: 40, style: 'logo'},
              {image: this.chapel, width: 54, height: 40, style: 'logo'},
              {image: this.factory, width: 54, height: 40, style: 'logo'},
              {image: this.coop, width: 54, height: 40, style: 'logo'},
              {image: this.printing, width: 54, height: 40, style: 'logo'},
            ],
          },
        ],
        footer: {
          // columns: [
          //     {
          //         text: 'Generated with Goodlife Savings & Credit Cooperative System',
          //         alignment: 'center',
          //         style: 'tableExample'
          //     }
          // ]
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 11,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.is_printing = false
    }
  },
}
</script>
